export default __webpack_public_path__ + "static/media/mx.10f3746d.svg";